/* automatically generated. do not edit */
import React, { lazy } from "react";
import Suspense from "../suspense";
import corebutton from "./core/button";
import corebuttons from "./core/buttons";
import corecolumn from "./core/column";
import corecolumns from "./core/columns";
import corecover from "./core/cover";
import coregallery from "./core/gallery";
import coregroup from "./core/group";
import coreimage from "./core/image";
import corepost from "./core/post";
import corepostdate from "./core/post-date";
import corepostexcerpt from "./core/post-excerpt";
import corepostfeaturedimage from "./core/post-featured-image";
import corepostpagination from "./core/post-pagination";
import coreposttemplate from "./core/post-template";
import corepostterms from "./core/post-terms";
import coreposttitle from "./core/post-title";
import corequery from "./core/query";
import corequerypagination from "./core/query-pagination";
import corequote from "./core/quote";
import coresearch from "./core/search";
import corespacer from "./core/spacer";
import coretermdescription from "./core/term-description";
import gcoaccordion from "./gco/accordion";
import gcocontent from "./gco/content";
import gcocoordinate from "./gco/coordinate";
import gcocoordinates from "./gco/coordinates";
import gcodefinitions from "./gco/definitions";
import gcoexternalcontent from "./gco/external-content";
import gcoicon from "./gco/icon";
import gcoiconandtext from "./gco/icon-and-text";
import gcoicongrid from "./gco/icon-grid";
import gcoslideshow from "./gco/slideshow";
import gcotabs from "./gco/tabs";
import gcotestimonialblock from "./gco/testimonial-block";
import woocommerceallproducts from "./woocommerce/all-products";
import woocommercefeaturedproduct from "./woocommerce/featured-product";
import woocommercefilter from "./woocommerce/filter";
import woocommercehandpickedproducts from "./woocommerce/handpicked-products";
import woocommerceproductbestsellers from "./woocommerce/product-best-sellers";
import woocommerceproductbutton from "./woocommerce/product-button";
import woocommerceproductbyattribute from "./woocommerce/product-by-attribute";
import woocommerceproductcategory from "./woocommerce/product-category";
import woocommerceproductcategorylist from "./woocommerce/product-category-list";
import woocommerceproductimage from "./woocommerce/product-image";
import woocommerceproductnew from "./woocommerce/product-new";
import woocommerceproductonsale from "./woocommerce/product-on-sale";
import woocommerceproductprice from "./woocommerce/product-price";
import woocommerceproductrating from "./woocommerce/product-rating";
import woocommerceproductsalebadge from "./woocommerce/product-sale-badge";
import woocommerceproductsku from "./woocommerce/product-sku";
import woocommerceproductstockindicator from "./woocommerce/product-stock-indicator";
import woocommerceproductsummary from "./woocommerce/product-summary";
import woocommerceproducttag from "./woocommerce/product-tag";
import woocommerceproducttaglist from "./woocommerce/product-tag-list";
import woocommerceproducttitle from "./woocommerce/product-title";
import woocommerceproductQueries from "./woocommerce/productQueries";
import woocommerceproducts from "./woocommerce/products";
const core = {
    "button": corebutton,
    "buttons": corebuttons,
    "column": corecolumn,
    "columns": corecolumns,
    "cover": corecover,
    "gallery": coregallery,
    "group": coregroup,
    "image": coreimage,
    "post": corepost,
    "post-date": corepostdate,
    "post-excerpt": corepostexcerpt,
    "post-featured-image": corepostfeaturedimage,
    "post-pagination": corepostpagination,
    "post-template": coreposttemplate,
    "post-terms": corepostterms,
    "post-title": coreposttitle,
    "query": corequery,
    "query-pagination": corequerypagination,
    "quote": corequote,
    "search": coresearch,
    "spacer": corespacer,
    "term-description": coretermdescription
};
const form = {};
const gco = {
    "accordion": gcoaccordion,
    "content": gcocontent,
    "coordinate": gcocoordinate,
    "coordinates": gcocoordinates,
    "definitions": gcodefinitions,
    "external-content": gcoexternalcontent,
    "icon": gcoicon,
    "icon-and-text": gcoiconandtext,
    "icon-grid": gcoicongrid,
    "slideshow": gcoslideshow,
    "tabs": gcotabs,
    "testimonial-block": gcotestimonialblock,
    "form": (props) => {
        const Block = lazy(() => import("./gco/form"));
        return React.createElement(Suspense, { fallback: React.createElement("form", null) },
            React.createElement(Block, { ...props }));
    },
    "map": (props) => {
        const Block = lazy(() => import("./gco/map"));
        return React.createElement(Suspense, { fallback: React.createElement("section", { className: "gco-map" },
                React.createElement("aside", null,
                    React.createElement("ul", null)),
                React.createElement("div", null)) },
            React.createElement(Block, { ...props }));
    },
    "pdfviewer": (props) => {
        const Block = lazy(() => import("./gco/pdfviewer"));
        return React.createElement(Suspense, { fallback: React.createElement("div", null) },
            React.createElement(Block, { ...props }));
    }
};
const woocommerce = {
    "all-products": woocommerceallproducts,
    "featured-product": woocommercefeaturedproduct,
    "filter": woocommercefilter,
    "handpicked-products": woocommercehandpickedproducts,
    "product-best-sellers": woocommerceproductbestsellers,
    "product-button": woocommerceproductbutton,
    "product-by-attribute": woocommerceproductbyattribute,
    "product-category": woocommerceproductcategory,
    "product-category-list": woocommerceproductcategorylist,
    "product-image": woocommerceproductimage,
    "product-new": woocommerceproductnew,
    "product-on-sale": woocommerceproductonsale,
    "product-price": woocommerceproductprice,
    "product-rating": woocommerceproductrating,
    "product-sale-badge": woocommerceproductsalebadge,
    "product-sku": woocommerceproductsku,
    "product-stock-indicator": woocommerceproductstockindicator,
    "product-summary": woocommerceproductsummary,
    "product-tag": woocommerceproducttag,
    "product-tag-list": woocommerceproducttaglist,
    "product-title": woocommerceproducttitle,
    "productQueries": woocommerceproductQueries,
    "products": woocommerceproducts
};
export default {
    core,
    form,
    gco,
    woocommerce,
};
